module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1517-927a67ac78fba00ba056f7b47191e078.png";